namespace Nobox.CRM {
    export interface AccountingsRow {
        Id?: number;
        TnId?: number;
        PlId?: number;
        DealId?: number;
        DealNm?: string;
        Date?: string;
        Currencies?: string;
        CtId?: string;
        FromName?: string;
        Desc?: string;
        Attachment?: string;
        Amount?: string;
        Payment?: string;
        ReferenceNumber?: string;
        In?: string;
        InBy?: number;
        Up?: string;
        UpBy?: number;
    }

    export namespace AccountingsRow {
        export const idProperty = 'Id';
        export const nameProperty = 'DealNm';
        export const localTextPrefix = 'Nobox.Accountings';
        export const lookupKey = 'Nobox.Accountings';

        export function getLookup(): Q.Lookup<AccountingsRow> {
            return Q.getLookup<AccountingsRow>('Nobox.Accountings');
        }
        export const deletePermission = 'Accountings:Delete';
        export const insertPermission = 'Accountings:Modify';
        export const readPermission = 'Accountings:View';
        export const updatePermission = 'Accountings:Modify';

        export declare const enum Fields {
            Id = "Id",
            TnId = "TnId",
            PlId = "PlId",
            DealId = "DealId",
            DealNm = "DealNm",
            Date = "Date",
            Currencies = "Currencies",
            CtId = "CtId",
            FromName = "FromName",
            Desc = "Desc",
            Attachment = "Attachment",
            Amount = "Amount",
            Payment = "Payment",
            ReferenceNumber = "ReferenceNumber",
            In = "In",
            InBy = "InBy",
            Up = "Up",
            UpBy = "UpBy"
        }
    }
}
